export default "__VITE_ASSET__DT1H$QsH__";